import { Component, OnInit } from '@angular/core';
import { MdDialog, MdDialogRef } from '@angular/material';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';

import { plainToClass } from 'class-transformer';
import { Observable } from 'rxjs/Observable';

import { ActivityDetails } from 'app/shared/components/activity/activity-details.model';
import { ActivityService } from 'app/shared/components/activity/activity.service';
import { ApplicationValue } from 'app/services/warmup/application-type.model';
import { WarmUpService, ApplicationTypeConstants } from 'app/services/warmup/warmup.service';
import { FormErrors } from 'app/shared/validators/generic-validators';
import { MessageService } from 'app/services/messages.service';
import { SnackBarService } from 'app/services/snackbar.service';

@Component({
  selector: 'editcategorysummary',
  templateUrl: './edit-activity-summary.component.html',
  styleUrls: ['./edit-activity-summary.component.css']
})
export class EditActivitySummaryComponent implements OnInit {

  editActivitySummaryForm: FormGroup;
  entityId: number;
  savingActivitySummary: boolean = false;
  summary: string;

  formErrors = {
    'summary': '',
  };

  validationMessages = {
    'summary': {
      'required': 'Required field value.',
      'maxlength': 'summary is too long.'
    },
  };

  constructor(
    public dialogRef: MdDialogRef<any>,
    private formBuilder: FormBuilder,
    private snackBarService: SnackBarService,
    private activityService: ActivityService,
    private warmUpService: WarmUpService
  ) { }

  ngOnInit() {
    this.editActivitySummaryForm = this.formBuilder.group({
      summary: ['', [Validators.required, Validators.maxLength(4000)]],
    });
    this.editActivitySummaryForm.valueChanges.subscribe(data => this.onValueChanged(data));
    this.updateCategorySummaryForm();
  }

  onValueChanged(data?: any) {
    if (!this.editActivitySummaryForm) {
      return;
    }
    FormErrors('editActivitySummaryForm', this);
  }

  updateCategorySummaryForm(): void {
    if (this.summary) {
      this.editActivitySummaryForm.patchValue({
        summary: this.summary,
      });
    }
  }

  onSubmit({ value, valid }): void {
    this.savingActivitySummary = true;
    const activitySummaryObj = {
      summary: value.summary,
      orgid: this.entityId
    };
    this.activityService.updateActivitySummary(activitySummaryObj)
      .subscribe(
      success => {
        this.savingActivitySummary = false;
        if (success.flagResult) {
          this.dialogRef.close(value.summary);
          this.callSnackBarService(success);
        }
      },
      err => {
        this.savingActivitySummary = false;
        this.callSnackBarService(err);
      });
  }

  callSnackBarService(response: any) {
    this.snackBarService.showStatus(
      response,
      MessageService.UPDATED_ACTIVITY_SUMMARY_SUCCESS,
      MessageService.ACTIVITY_FAILURE);
  }


}



// WEBPACK FOOTER //
// ./src/app/shared/components/activity/editactivitysummary/edit-activity-summary.component.ts